<template lang="pug">
md-layout(md-column)
  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Playlists', :nav='nav')
    router-link(:to='{ name: "CreatePlaylist" }')
      md-button.md-fab.md-fab-bottom-right.md-icon-button
        md-icon(md-iconset="fa fa-plus")
    playlist-table.content-table
</template>

<script>
  import PlaylistTable from '../../shared-components/playlist/PlaylistTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      PlaylistTable,
      Breadcrumbs
    },
    computed: {
      nav() {
        return [
          { title: 'Playlists' }
        ]
      },
    }
  };
</script>

<style lang="scss" scoped>
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
  .content-table {
    margin: 25px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/playlist/PlaylistList.vue